import wordmark from '../../assets/brand/acercate_logo.png';
import isotipo from '../../assets/brand/ic_simbolo_corp_ac.png';

export const CustomLogoApp = ({
  variant = 'wordmark',
  height = 120,
  alt = 'Acércate',
  ...props
}) => {
  const src = variant === 'isotipo' ? isotipo : wordmark;
  const resolvedHeight = Math.max(Number(height) || 24, 24);

  return (
    <img
      src={src}
      alt={alt}
      height={resolvedHeight}
      style={{
        height: resolvedHeight,
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        minHeight: 24,
      }}
      {...props}
    />
  );
};
